import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WHATSAPP_NUMBER, WHATSAPP_PREFILL } from "../config/site";

const WhatsAppGlyph = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current" aria-hidden="true">
    <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 1.8a8.2 8.2 0 1 1-4.2 15.3l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 0 1 12 3.8Zm-3 4c-.2 0-.5.1-.7.3-.6.6-1.1 1.5-1.1 2.6 0 1.6 1 3.2 2.3 4.6 1.4 1.5 3 2.5 4.8 2.9 1.2.2 2.2 0 2.9-.7.3-.3.5-.8.5-1.3 0-.2-.1-.4-.2-.5l-1.7-.9c-.2-.1-.5-.1-.7.1l-.7.9c-.1.2-.3.2-.5.1-1.2-.5-2.2-1.1-3-2-.7-.8-1.2-1.7-1.5-2.7-.1-.2 0-.4.1-.5l.8-.8c.2-.2.2-.4.1-.6l-.9-1.8c-.1-.2-.3-.4-.5-.4Z" />
  </svg>
);

export const WhatsAppSigil = () => {
  const [hover, setHover] = useState(false);
  if (!WHATSAPP_NUMBER) return null;

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_PREFILL)}`;

  return (
    <motion.a
      data-testid="whatsapp-sigil-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Message the practitioner on WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.2, type: "spring", stiffness: 200, damping: 14 }}
      onHoverStart={() => setHover(true)}
      onHoverEnd={() => setHover(false)}
      className="fixed bottom-6 right-6 z-[60] flex items-center gap-3 group"
    >
      <AnimatePresence>
        {hover && (
          <motion.span
            initial={{ opacity: 0, x: 12 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 12 }}
            transition={{ duration: 0.25 }}
            className="hidden sm:block parchment-card rounded-full px-4 py-2 text-[10px] uppercase tracking-[0.2em] font-mono text-gold whitespace-nowrap"
          >
            Speak with the Practitioner
          </motion.span>
        )}
      </AnimatePresence>

      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-arcanacard border border-gold/60 text-gold shadow-[0_0_25px_rgba(212,175,55,0.25)] transition-all duration-300 group-hover:bg-gold group-hover:text-ink group-hover:shadow-[0_0_40px_rgba(212,175,55,0.5)]">
        <span className="absolute inset-0 rounded-full border border-gold/40 animate-ping [animation-duration:2.5s]" aria-hidden="true" />
        <WhatsAppGlyph />
      </span>
    </motion.a>
  );
};
